import copy from 'copy-to-clipboard';

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    copy(text);
    return Promise.resolve(true);
  } catch (err) {
    console.error('copy failed:', err);
    return Promise.reject(err);
  }
};
